import * as HLF from "html-living-framework";
import { getTexture, setParent } from "html-living-framework/lib/Utils/PixiUtils";
import { Emitter } from "pixi-particles";
import * as AssetHelpers from "../core/AssetHelpers";
import { texture } from "../core/AssetHelpers";
import { HoverableButton, TextureButton } from "../core/Button";
import { Callback, Mix } from "../core/Reflection";
import { Sprite } from "../core/Sprite";
import { TransformBackup } from "../core/TransformBackup";
import { LightsOutObjectType } from "../data/LightsOutObjectType";
import { TrashType } from "../data/TrashType";
import { GlowFilter } from "../filters/GlowFilter";
import { OutlineFilter } from "../filters/OutlineFilter";
import { Button } from "./Button";
import { LightsOutObject } from "./LightsOutObject";

const emitterConfig = {
    alpha: {
        start: 0.75,
        end: 1,
    },
    scale: {
        start: 1,
        end: 0.001,
        minimumScaleMultiplier: 0.5,
    },
    color: {
        start: "#ffffff",
        end: "#ffffff",
    },
    speed: {
        start: 200,
        end: -20,
        minimumSpeedMultiplier: 1,
    },
    acceleration: {
        x: 0,
        y: 0,
    },
    maxSpeed: 0,
    startRotation: {
        min: 270,
        max: 360,
    },
    noRotation: true,
    rotationSpeed: {
        min: 0,
        max: 0,
    },
    lifetime: {
        min: 0.5,
        max: 1,
    },
    blendMode: "normal",
    frequency: 0.2,
    emitterLifetime: -1,
    maxParticles: 1500,
    pos: {
        x: 0,
        y: 0,
    },
    addAtBack: true,
    spawnType: "point",
};

export class Radio extends LightsOutObject {

    protected musicNotesContainer = this.addChild(new PIXI.Container());
    protected musicNotes = new Emitter(this.musicNotesContainer, [
        texture("musicnote1"),
        texture("musicnote2"),
        texture("musicnote3"),
        texture("musicnote4"),
        texture("musicnote5"),
        texture("musicnote6"),
    ], emitterConfig);

    constructor() {
        super({ type: LightsOutObjectType.Electricity });
        this.name = "radio";
    }

    public onLayout() {
        super.onLayout();
        this.musicNotes.emit = false;
        this.musicNotes.autoUpdate = true;
    }

    public TurnOn(pOptions: {animate: boolean} = {animate: true}): void {
        super.TurnOn(pOptions);
        this.musicNotes.emit = true;
    }

    public TurnOff(pOptions?: { animate: boolean }): void {
        super.TurnOff(pOptions);
        this.musicNotes.emit = false;
    }

    public Highlight() {
        super.Highlight();
    }

    public UnHighlight() {
        super.UnHighlight();
    }
    public destroy() {
        this.musicNotes.cleanup();
        this.musicNotes.autoUpdate = false;
        super.destroy();
    }
}
